import React, { useState } from "react";
import "./modal-client.scss";
import DialogTitle from "../../../components/modal-components/dialog-title";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import avatar from "../../../components/img/no_avatar.png";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog/Dialog";
import { savePhotoOffice } from "../../../store/actions/selects";
import { useDispatch } from "react-redux";
import Compress from "compress.js";
import { savePhotoAdmin } from "../../../store/actions/client";

const ChangePhoto = (props) => {
  const { open, setOpen, item, collection, admin } = props;
  const dispatch = useDispatch();
  const initialState = { alt: "", src: "", file: "" };
  const [{ alt, src, file }, setPreview] = useState(initialState);

  const onClose = () => {
    setPreview(initialState);
    setOpen(!open);
  };

  const compress = new Compress();

  const resizeImageFn = async (file) => {
    const resizedImage = await compress.compress([file], {
      size: 2,
      quality: 1,
      maxWidth: 1920,
      maxHeight: 1080,
      resize: true,
      name: file.name,
    });
    const img = resizedImage[0];
    const base64str = img.data;
    const imgExt = img.ext;
    return Compress.convertBase64ToFile(base64str, imgExt);
  };

  const fileHandler = (event) => {
    const { files } = event.target;
    const size = files[0]?.size / 1048576;
    if (size > 1.95) {
      resizeImageFn(files[0]).then((image) => {
        setPreview(
          files.length
            ? {
                file: image,
                src: URL.createObjectURL(image),
                alt: image.name,
              }
            : initialState
        );
      });
    } else
      setPreview(
        files.length
          ? {
              file: files[0],
              src: URL.createObjectURL(files[0]),
              alt: files[0].name,
            }
          : initialState
      );
  };

  const saveAvatar = () => {
    const id = item.id;
    if (admin) {
      dispatch(savePhotoAdmin(file, collection, id));
      setPreview(initialState);
      setOpen(!open);
    } else {
      dispatch(savePhotoOffice(file, collection, id));
      setPreview(initialState);
      setOpen(!open);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="form-dialog"
      fullWidth
      maxWidth={"xs"}
    >
      <DialogTitle id="form-dialog" onClose={onClose} />
      <DialogContent id="changeAvatarClient">
        <div className="addNewClient">
          {src !== "" ? (
            <img className="previewClient" src={src} alt={alt} />
          ) : (
            <img
              alt="avatar"
              src={item.avatar?.full_url || avatar}
              className="previewClient"
            />
          )}
          <input
            accept="image/jpg, image/jpeg, image/png"
            type="file"
            onChange={fileHandler}
          />
        </div>
      </DialogContent>
      <DialogActions
        className="changeAvatarClientBtn"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          disabled={src === ""}
          onClick={saveAvatar}
        >
          Сохранить
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePhoto;
